import { createModalToken } from "@/modal-manager";
import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type MoneyExchangerInterface from "@modules/money/MoneyExchanger/MoneyExchangerInterface";
import type { InjectionToken } from "tsyringe";

import type DrawerManager from "@components/Drawer/DrawerManager";
import type { LoggerInterface } from "@interfaces/LoggerInterface";

import type { ModalParams, RefundModalParams } from "./utils/modal/types";

export const rewardsApplicationLoggerToken = Symbol(
    "rewardsApplicationLoggerToken"
) as InjectionToken<LoggerInterface>;

export const rewardsAuthApiClientToken = Symbol(
    "rewardsAuthApiClientToken"
) as InjectionToken<ApiClientInterface>;

export const rewardsAuthApiClientV3Token = Symbol(
    "rewardsAuthApiClientV3Token"
) as InjectionToken<ApiClientInterface>;

export const rewardsMoneyExchangerToken = Symbol(
    "rewardsMoneyExchangerToken"
) as InjectionToken<MoneyExchangerInterface>;

export const drawerManagerToken = Symbol(
    "drawerManagerToken"
) as InjectionToken<DrawerManager>;

export const rewardsVerifyAccountModalWidgetToken = createModalToken(
    "RewardsVerifyAccountModalWidget"
);

export const rewardsJoinNowModalWidgetToken = createModalToken(
    "RewardsJoinNowModalWidget"
);

export const rewardsQrCodeModalWidgetToken = createModalToken(
    "RewardsQrCodeModalWidget"
);

export const rewardsWaysToEarnPageWidgetModalToken =
    createModalToken<ModalParams>("RewardsWaysToEarnPageWidgetModal");

export const rewardsWaysToSpendPageWidgetModalToken =
    createModalToken<ModalParams>("RewardsWaysToSpendPageWidgetModal");

export const rewardsAvailableRewardsPageWidgetModalToken =
    createModalToken<ModalParams>("RewardsAvailableRewardsPageWidgetModal");

export const rewardsAvailableStoreCreditPageWidgetModalToken =
    createModalToken<ModalParams>("RewardsAvailableStoreCreditPageWidgetModal");

export const rewardsRefundDiscountModalWidgetToken =
    createModalToken<RefundModalParams>("RewardsRefundDiscountModalWidget");
